export const aboutIntro = {
  eyebrow: 'About our school',
  title: 'A state school built around eighteen children at a time.',
  lede: "Toddler's Academy opened in 1998 in a two-room building on Ogundele Way. Twenty-eight years later we teach 412 children from two to sixteen, still free, still on the same street, still refusing to let a class grow past eighteen.",
};

export const beliefs = [
  {
    title: 'A teacher must be able to name every child',
    body: 'Class size is the one thing we never trade. Eighteen is the ceiling, and we have turned down funding that would have raised it.',
  },
  {
    title: 'Free means genuinely free',
    body: 'No tuition, no uniform bill, no exam levy, no lunch charge. A family should never be asked for money at the school gate.',
  },
  {
    title: 'Children stay, and so do teachers',
    body: 'Twenty-two of our thirty-one teachers have been here more than five years. Continuity is not a perk — it is the method.',
  },
];

export const aboutStats = [
  { value: '1998', label: 'the year we opened, with 24 children' },
  { value: '412', label: 'pupils on roll across three stages' },
  { value: '31', label: 'teachers, 22 here over five years' },
  { value: '2,900', label: 'children taught since we opened' },
];
